<template>
  <section class="avatar-menu">
    <v-menu bottom right nudge-bottom="62">
      <template v-slot:activator="{ on }">
        <v-btn
          text
          v-on="on"
          class="avatar_button"
          :disabled="$vuetify.breakpoint.mdAndUp"
        >
          <avatar class="main-avatar" :size="32" :username="name"></avatar>
          <span class="ml-1" v-show="$vuetify.breakpoint.mdAndUp">
            Hi {{ name | capitalize }}
          </span>
          <v-icon v-show="!$vuetify.breakpoint.mdAndUp">
            keyboard_arrow_down
          </v-icon>
        </v-btn>
      </template>
      <v-list v-if="!$vuetify.breakpoint.mdAndUp">
        <v-list-item>
          <v-list-item-action>
            <v-icon left>sync_alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Switch Account
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item
          v-for="u in connectedAccounts"
          @click="switchAccount(me, u)"
          :key="u.id"
        >
          <v-list-item-content>
            <v-list-item-title class="primary--text">
              {{ u.first_name }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon right v-if="u.type === 'individual'">emoji_people</v-icon>
            <v-icon right v-else>wc</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="!$vuetify.breakpoint.mdAndUp" />
        <v-list-item
          @click="logout(`${$route.meta.type}`)"
          v-if="!$vuetify.breakpoint.mdAndUp"
        >
          <v-list-item-action>
            <v-icon left>exit_to_app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              logout
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
      bottom
      right
      nudge-bottom="62"
      v-if="parentOrChild && $vuetify.breakpoint.mdAndUp"
    >
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <span class="ml-1">
            Switch Account
          </span>
          <v-icon right>
            sync_alt
          </v-icon>
        </v-btn>
      </template>
      <v-list v-if="connectedAccounts.length">
        <v-list-item
          v-for="u in connectedAccounts"
          @click="switchAccount(me, u)"
          :key="u.id"
        >
          <v-list-item-content>
            <v-list-item-title class="primary--text">
              {{ u.first_name }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon right v-if="u.type === 'individual'">person</v-icon>
            <v-icon right v-else>people</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <p v-else class="ma-2">
        Add children accounts
        <router-link to="/parent/dashboard/children">here</router-link>
      </p>
    </v-menu>
    <v-btn icon large @click="redirectToHelpPage" class="pl-4" v-if="isTeacher">
      <v-icon left>help</v-icon>
    </v-btn>
    <notification
      v-if="$route.meta.type !== 'individual'"
      ref="notification"
      :type="$route.meta.type + 's'"
    />
    <v-btn
      text
      @click="logout(`${$route.meta.type}`)"
      class="pl-3"
      v-show="$vuetify.breakpoint.mdAndUp"
    >
      <v-icon left>exit_to_app</v-icon>
      logout
    </v-btn>
  </section>
</template>
<script>
import Auth from '@/modules/auth/models/Auth'
import Avatar from 'vue-avatar'
import Notification from '@/components/notification/Notification'
import Parent from '@/modules/parent/models/Parent'
import Individual from '@/modules/individual/models/Individual'
import switchAccount from '@/modules/auth/mixins/switchAccount'
import authLogout from '@/modules/auth/mixins/authLogout'

export default {
  name: 'AvatarMenu',
  mixins: [switchAccount, authLogout],
  components: {
    Avatar,
    Notification
  },
  async mounted() {
    if (this.$route.meta.type === 'parent') {
      await Parent.dispatch('getChildren')
    } else if (this.$route.meta.type === 'individual') {
      await Individual.dispatch('getSiblings')
    }
  },
  computed: {
    me() {
      let type = this.$route.meta.type
      if (type == 'user') type = 'student'
      return Auth.query()
        .where('type', type)
        .first()
    },
    connectedAccounts() {
      if (!this.me) return []
      if (this.$route.meta.type === 'parent') {
        return Individual.all()
      } else if (this.$route.meta.type === 'individual') {
        return [this.me.individual_meta.parent_user, ...Individual.all()]
      }
      return []
    },
    isTeacher() {
      const auth = Auth.query()
        .where('type', this.$route.meta.type)
        .first()
      if (!auth) return false

      return auth.type === 'teacher'
    },
    name() {
      let type = this.$route.meta.type
      if (type == 'user') type = 'student'
      const auth = Auth.query()
        .where('type', type)
        .first()
      if (!auth) return ''

      if (
        auth.type === 'teacher' ||
        auth.type === 'parent' ||
        auth.type === 'individual'
      ) {
        return auth.first_name
      } else if (this.$store.state.isSDECC == 1 && type != 'client') {
        return auth.profile[0].first_name + ' ' + auth.profile[0].last_name
      } else {
        return auth.email
      }
    },
    parentOrChild() {
      if (
        this.$route.meta.type === 'parent' ||
        this.$route.meta.type === 'individual'
      ) {
        return true
      }

      return false
    }
  },
  methods: {
    redirectToHelpPage() {
      this.$router.push('support')
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-menu {
  display: flex;
  align-items: center;

  .main-avatar {
    display: inline-flex !important;
    margin-right: 5px;
    span {
      font-weight: bold;
    }
  }

  .avatar_button {
    text-transform: initial;
    color: white !important;
  }

  .visiblility {
    visibility: hidden;
  }
}
</style>
